import React, { useEffect, useState } from 'react';
import { jsonEditorStyles } from '../jsonEditorStyles';
import Button from '@mui/material/Button';
import useComponentUIHook from './useComponentUIHook';
import { SelectComponent, TextComponent, TooltipComponent } from '../../uiComponents';
import { Radio, RadioGroup, SelectChangeEvent } from '@mui/material';
import { OptionProps } from '../../../view-models';
import { getJSONClaims, setJSONClaims } from '../../../store';
import jsonComponents from '../../../constants/jsonComponents';
import { useSelector, useDispatch } from 'react-redux';
import { getNodeData, setNodeData } from '../../../store';

interface componentProps {
    componentData: any;
    closeGritComponent: any;
    setUnsavedChanges: any;
}

const GenerateValidationErrorUI = ({ componentData, closeGritComponent, setUnsavedChanges }: componentProps) => {
    const { modifiedData, setModifiedData, checkIfSameIgnoringSubFlows } = useComponentUIHook(componentData);
    const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
    
    const nodeData = useSelector(getNodeData);
    const [currentMessage, setCurrentMessage] = useState<string>(nodeData[modifiedData['subflowParent']].validationErrorMessage);

    const classes = jsonEditorStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        const _res = currentMessage === nodeData[modifiedData['subflowParent']].validationErrorMessage
        setDisableSubmit(_res);
        setUnsavedChanges(_res);
      }, [currentMessage]);

    return (
        <div>
            <div className={classes.subHeading}>Validation Error</div>
            <div>
                <TextComponent
                    data={{
                        label: 'Error Message',
                        value: currentMessage ? currentMessage : '',
                        style: { margin: 1, width: 450 },
                    }}
                    changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>)  => {
                        setCurrentMessage(e.target.value);
                    }}
                />
                <TooltipComponent
                    title=''
                    desc='This error message will be shared across all validation error components in this submit action'
                />
            </div>
            <div>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    onClick={() => {
                        dispatch(setNodeData({ [modifiedData['subflowParent']]: {...nodeData[modifiedData['subflowParent']], validationErrorMessage: currentMessage }}))
                        closeGritComponent(modifiedData, null, false);
                        setDisableSubmit(true);
                        setUnsavedChanges(true);
                    }}
                    disabled={disableSubmit}
                >
                    Save
                </Button>
            </div>
        </div>
    )

}

export default GenerateValidationErrorUI;